const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];
const STORE = "rl_utm";

export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 200);
  });
  if (Object.keys(found).length) {
    const prev = getUtm();
    sessionStorage.setItem(STORE, JSON.stringify({ ...prev, ...found }));
  }
}

export function getUtm() {
  try {
    const data = JSON.parse(sessionStorage.getItem(STORE) || "{}");
    return KEYS.reduce((acc, k) => ({ ...acc, [k]: data[k] || "" }), {});
  } catch {
    return KEYS.reduce((acc, k) => ({ ...acc, [k]: "" }), {});
  }
}
